import { apiURL } from '../../../utilities/URLs'

export default function DashboardCompleteIDme() {
  const idmeState = localStorage.getItem('idme')
  const idmeSpouseState = localStorage.getItem('idmeSpouse')
  const state = idmeState === '1' ? '&state=resync' : idmeState === '2' ? '&state=upload' : (idmeSpouseState && idmeSpouseState === '1') ? '&state=spouse' : ''
  const idMeURL = `${process.env.REACT_APP_IDME_API_DOMAIN}/oauth/authorize?client_id=${process.env.REACT_APP_IDME_CLIENT_ID}&redirect_uri=${apiURL}/idme&response_type=code&scope=openid%20http://idmanagement.gov/ns/assurance/ial/2/aal/2${state}`

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4 mt-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-8'>
          <button onClick={() => window.location.href = idMeURL}>
            <img className='w-56 h-11' src='https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg' />
          </button>
          <p className='font-bold text-xl'>To complete your ID.me process, please click the button above.</p>
          </div>
        </div>
      </div>
    </div>
  )
}